import Link from "@iso/components/Link/Link";
import { createNotification } from "@iso/components/Notification";
import IntlMessages from "@iso/components/utility/intlMessages";
import { Button, Form, Input } from "antd";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import ForgotPasswordStyleWrapper from "./ForgotPassword.styles";
import API from "../../../library/helpers/api";
import { SidePanel } from "../../../components/SidePanel/SidePanel";
import { Navbar } from "../../../components/Navbar/Navbar";
import { useIntl } from "react-intl";

export default function ForgotPassword() {
  const intl = useIntl();
  let navigate = useNavigate();
  let location = useLocation();
  const isLoggedIn = useSelector((state) => state.Auth.idToken);

  const [email, setEmail] = React.useState();
  const [redirectToReferrer, setRedirectToReferrer] = React.useState(false);
  const [isLoading, setLoading] = React.useState(false);

  useEffect(() => {
    if (isLoggedIn) {
      setRedirectToReferrer(true);
    }
  }, [isLoggedIn]);

  let { from } = location.state || { from: { pathname: "/dashboard" } };

  if (redirectToReferrer) {
    return <Navigate to={from} />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    await API.sendResetPasswordCode(email)
      .then((result) => {
        createNotification(
          "success",
          intl.formatMessage({ id: "page.my-account.password.success.title" }),
          intl.formatMessage({
            id: "page.my-account.password.success.description",
          }),
        );
        navigate("/login");
      })
      .catch((error) => {
        console.error(error);
        if (error.response.data) {
          createNotification("error", "Fail", error.response.data.message);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <Navbar />
      <ForgotPasswordStyleWrapper className="isoSignInPage">
        <div className="isoLoginContentWrapper">
          <div className="isoLoginContent">
            <h3>
              <IntlMessages id="page.forgotPasswordTitle" />
            </h3>
            <p style={{ marginBottom: 10 }}>
              <IntlMessages id="page.forgotPasswordParagraph" />
            </p>
            <div className="isoSignInForm">
              <Form layout="vertical">
                <Form.Item
                  label="E-mail"
                  rules={[
                    { required: true, message: "Please input your email!" },
                  ]}
                >
                  <Input
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="saffe@saffe.com"
                    size={"large"}
                  />
                </Form.Item>
                <div className="flex justify-between items-center">
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <IntlMessages id="page.signInCreateAccount" />
                    <Link
                      to="/register"
                      className="text-primary hover:text-primary cursor-pointer"
                    >
                      <IntlMessages id="page.signInCreateAccountLink" />
                    </Link>
                  </div>
                  <Button
                    className="bg-primary border-0 text-white !px-6 shadow-none"
                    size="large"
                    shape="round"
                    htmlType="submit"
                    type="primary"
                    loading={isLoading}
                    onClick={handleSubmit}
                  >
                    <IntlMessages id="page.forgotPasswordCTA" />
                  </Button>
                </div>
              </Form>
              <div className="isoCenterComponent isoHelperWrapper"></div>
            </div>
          </div>
        </div>
        <SidePanel />
      </ForgotPasswordStyleWrapper>
    </>
  );
}
